<main id="db-wrapper" class="bg-light">

    <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  
    <section id="page-content">
      <div class="header">
        <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
        <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
      </div>
  
      <div class="container-fluid p-4">
        <div class="row">
            <div class="col-lg-12">
                <div class="card p-5 ">
                    <div class="card-header">
                       <h2>
                        {{'DeleteMyAccount' | translate}}
                       </h2>
                    </div>
                    <div class="card-body">
                        <div class="d-grid">
                            <button class="btn btn-danger" (click)="confirm1($event)">
                               {{"DeleteMyAccount" | translate}}
                            </button>
                            <p-confirmdialog />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </section>
  </main>
  <div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
    <app-bottom-nav></app-bottom-nav>
  </div>